import * as React from 'react';
import styles from './index.less';
import { Sider_OnChange_Page_Action, Sider_OnMount_Page_Action } from '@/models/collectionManager';
import * as AHooks from 'ahooks';
import { useParams } from 'umi';
import { connect } from 'dva';
import { ConnectState, ResourceAuthPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import FComponentsLib from '@freelog/components-lib';
import FTable from '@/components/FTable';
import FContractDetailsDrawer2, {
  setState_FContractDetailsDrawer2,
} from '@/components/FContractDetailsDrawer2';
import type { ColumnsType } from 'antd/es/table';
import { Space } from 'antd';
import { OnMount_ContractPage_Action } from '@/models/resourceAuthPage';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';
import FContractStatusBadge from '@/components/FContractStatusBadge';

interface ContractProps {
  dispatch: Dispatch;
  resourceAuthPage: ResourceAuthPageModelState;
}

function Contract({ dispatch, resourceAuthPage }: ContractProps) {
  const params = useParams<{ id: string }>();
  AHooks.useMount(async () => {
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });
    dispatch<Sider_OnChange_Page_Action>({
      type: 'collectionManager/sider_onChange_Page',
      payload: {
        page: 'contract',
      },
    });
    dispatch<OnMount_ContractPage_Action>({
      type: 'resourceAuthPage/onMount_ContractPage',
      payload: {
        resourceID: params.id!,
      },
    });
  });

  const columns: ColumnsType<ResourceAuthPageModelState['contractsAuthorize'][number]> = [
    {
      title: (
        <FComponentsLib.FTitleText
          // text={'被授权方'}
          text={FI18n.i18nNext.tAuto('contract_licensee')}
          type='table'
        />
      ),
      dataIndex: 'authorized',
      width: 300,
      render: (_: any, record) => {
        return (
          <Space size={5}>
            {record.licenseeIdentityType === 'resource' && <FIcons.FResource />}
            {record.licenseeIdentityType === 'node' && <FIcons.FNodes />}
            {record.licenseeIdentityType === 'user' && <FIcons.FUser />}
            <a
              onClick={async () => {
                if (record.licenseeIdentityType === 'resource') {
                  self.open(
                    FUtil.LinkTo.resourceDetails({
                      resourceID: record.licenseeID,
                    }),
                  );
                } else if (record.licenseeIdentityType === 'node') {
                  const {
                    data,
                  }: {
                    data: {
                      nodeDomain: string;
                    };
                  } = await FServiceAPI.Node.details({
                    nodeId: Number(record.licenseeID),
                  });
                  // console.log(data, 'datapoisdjfl;ksdjfljsdlfjsdlkfjsldkjlkj');
                  self.open(FUtil.Format.completeUrlByDomain(data.nodeDomain));
                }
              }}
            >
              <FComponentsLib.FContentText type='highlight' text={record.authorizedParty} />
            </a>
          </Space>
        );
      },
    },
    {
      title: (
        <FComponentsLib.FTitleText
          // text={'所签授权策略｜合约状态'}
          text={FI18n.i18nNext.tAuto('contract_list_contracts')}
          type='table'
        />
      ),
      dataIndex: 'contract',
      width: 240,
      render: (_: any, record) => {
        return (
          <div>
            <Space size={5}>
              <FComponentsLib.FContentText type='highlight' text={record.contractName} />
              {/* <FComponentsLib.FContractStatusBadge status={record.status} /> */}
              <FContractStatusBadge status={record.status} />
            </Space>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              type='additional2'
              // text={'创建时间：' + record.createDate}
              text={FI18n.i18nNext.tAuto('contract_signed_time') + ' ' + record.createDate}
            />
            <FComponentsLib.FContentText
              type='additional2'
              // text={'合约ID：' + record.contractID}
              text={FI18n.i18nNext.tAuto('contract_id') + ' ' + record.contractID}
            />
          </div>
        );
      },
    },
    {
      // title: <FComponentsLib.FTitleText text={'操作'} type="table" />,
      title: null,
      dataIndex: 'operation',
      width: 80,
      render: (_: any, record) => {
        return (
          <FComponentsLib.FTextBtn
            onClick={() => {
              // onChange({
              //   detailContractID: record.contractID,
              // });
              setState_FContractDetailsDrawer2({
                contractId: record.contractID,
                contractDetailShow: true,
              });
            }}
          >
            {/* 查看合约 */}
            {FI18n.i18nNext.tAuto('contract_list_btn_viewcontract')}
          </FComponentsLib.FTextBtn>
        );
      },
    },
  ];

  // function onChange(payload: Partial<ResourceAuthPageModelState>) {
  //   dispatch<ChangeAction>({
  //     type: 'resourceAuthPage/change',
  //     payload: payload,
  //   });
  // }

  return (
    <>
      <div className={styles.root}>
        <div style={{ height: 40 }} />
        <div className={styles.block}>
          <FComponentsLib.FContentText
            // text={'授权合约'}
            // text={FI18n.i18nNext.tAuto('licenceecontracts_title')}
            text={FI18n.i18nNext.tAuto('edit_resource_tab_licenceecontracts')}
            type={'highlight'}
          />

          {resourceAuthPage.contractsAuthorize.length === 0 && (
            <>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FComponentsLib.FContentText text={'暂无合约'} type={'additional2'} />
              </div>
            </>
          )}

          {resourceAuthPage.contractsAuthorize.length > 0 && (
            <>
              <div style={{ height: 20 }} />
              <FTable
                columns={columns}
                dataSource={resourceAuthPage.contractsAuthorize}
                pagination={false}
              />
            </>
          )}
        </div>
        <div style={{ height: 100 }} />
        <FContractDetailsDrawer2
          // contractID={resourceAuthPage.detailContractID}
          onClose={() => {
            // onChange({
            //   detailContractID: '',
            // });
          }}
        />
      </div>
    </>
  );
}

// export default Contract;

export default connect(({ resourceAuthPage }: ConnectState) => ({
  resourceAuthPage: resourceAuthPage,
}))(Contract);
